import { createContext, useEffect, useState } from 'react';
import { addToLog } from '../utilities/Updates';
import { Network } from '@capacitor/network';

export const InternetConnectionStatusContext = createContext({
  hasInternetConnection: false,
  internetConnectionType: null,
});

export default function InternetConnectionStatus({ children }) {
  const [internetConnectionSet, setInternetConnectionSet] = useState(false);
  const [hasInternetConnection, setHasInternetConnection] = useState(false);
  const [internetConnectionType, setInternetConnectionType] = useState(null);

  const updateInternetConnectionStatus = (status) => {
    setHasInternetConnection(status.connected);
    setInternetConnectionType(status.connected ? 'connected' : null);
    setInternetConnectionSet(true); //this should be false until it is set and then it remains true

    addToLog('network_status_change', status);
  };

  useEffect(() => {
    Network.getStatus().then(updateInternetConnectionStatus);

    const networkListener = Network.addListener(
      'networkStatusChange',
      updateInternetConnectionStatus,
    );

    return () => networkListener.remove();
  }, []);

  return (
    <InternetConnectionStatusContext.Provider value={{
      hasInternetConnection,
      internetConnectionType,
      internetConnectionSet,
    }}>
      { children }
    </InternetConnectionStatusContext.Provider>
  );
}
